<template>
  <div class="mat1x-fire-container">
    <!-- <swiper ref="swiperRef" :options="swiperOptions"> -->
    <!-- <swiper-slide class="slide-content"> -->
    <div class="section">
      <Banner :cgVideo="cgVideo" :downloadUrl="downloadUrl" :downloadGift="downloadGift" />
    </div>
    <!-- </swiper-slide> -->
    <!-- <swiper-slide class="slide-content"> -->
    <div class="section">
      <Statistics :titleData="titleData" />
    </div>
    <!-- </swiper-slide> -->
    <!-- <swiper-slide class="slide-content"> -->
    <div class="section">
      <GlobalPlayer :mapText="mapText" />
    </div>
    <!-- </swiper-slide> -->
    <!-- </swiper> -->
    <Footer ref="footerRef"></Footer>
  </div>
</template>

<script>
import Banner from "./components/banner/index.vue";
import Statistics from "./components/statistics/index.vue";
import GlobalPlayer from "./components/globalPlayer/index.vue";
import Footer from "./components/footer/index.vue";
import { fireLanding } from "@/api/json";
import { JSONSTORAGEADDRESS } from "@/config";

export default {
  name: "Matr1xFireIntro",
  components: { Footer, Banner, Statistics, GlobalPlayer },
  data() {
    return {
      swiperOptions: {
        speed: 1000,
        observer: true,
        observeParents: true,
        autoplay: false,
        loop: false,
        mousewheel: true,
        autoHeight: true,
        direction: 'vertical'
      },
      cgVideo: null,
      downloadUrl: null,
      downloadGift: null,
      titleData: null,
      mapText: null
    };
  },
  mounted() {
    this.getJsonConfig();
  },
  methods: {
    getJsonConfig() {
      fetch((process.env.NODE_ENV === 'development' ? '' : JSONSTORAGEADDRESS) + fireLanding).then(async res => {
        if (res.status == 200) {
          const result = await res.json();
          this.cgVideo = result.cg.cg;
          this.downloadUrl = result.downloadUrl;
          this.downloadGift = result.downloadGift;
          this.titleData = result.data;
          this.mapText = result.map;
        }
      })
    },
  }
};
</script>

<style lang="scss">
.mat1x-fire-intro-main-width {
  max-width: 1580px;
  margin: 0 auto;
  font-family: Poppins-Regular !important;
  box-sizing: border-box;

  @media screen and (min-width: 769px) and (max-width: 1580px) {
    max-width: 100%;
    width: 100%;
    padding: 0 40px;
  }

  @media screen and (max-width: 769px) {
    max-width: 100%;
    width: 100%;
    padding: 0 16px;
  }
}
</style>

<style lang="scss" scoped>
@import "./index.scss";
</style>
